<template>
  <div class="form_wrapper">
    <step-status :step="$route.meta.step" class="mt55"></step-status>
    <components :is="fillformStatus" :status="$route.query.status"></components>
  </div>
</template>
<script>
import fillformNormal from './fillform_normal'
import fillformPending from './fillform_pending'

export default {
  data() {
    return {
      fillform: fillformNormal
    }
  },

  computed: {
    fillformStatus() {
      let status = this.$route.query.status
      return status ? fillformPending : fillformNormal
    }
  },

  components: {
    fillformNormal,
    fillformPending
  }
}
</script>

<style lang="less">
.form_wrapper {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 100px;

  > img {
    margin-top: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// fillform.vue?7d60ab88